<script>
    import { setContext, onMount } from "svelte";
    import { writable } from "svelte/store";
    import { get_store_value } from "svelte/internal";
    import { searchStore } from "./stores/state.js";


    setContext("searchStore", searchStore);

</script>
<slot></slot>
